import styled from "styled-components";
import { globalStyles } from "../../util/globalStyles";

export const HighStreetRetailShoppingWrapper = styled.div`
    text-align: center;
    margin-top: 5rem;
    margin-bottom: 5rem;
`

export const ContentWrapper = styled.div`
    margin-top: 4rem;
    display: flex;
    justify-content: space-between;
    background-color: #dbeafe;

    @media only screen and (max-width: ${globalStyles.breakpoints.medium}) {
        flex-direction: column;
    }
`

export const LeftImage = styled.img`
    width: 30%;

    @media only screen and (max-width: ${globalStyles.breakpoints.medium}) {
        width: 100%;
    }
`
export const RightImage = styled.img`
    width: 30%;

    @media only screen and (max-width: ${globalStyles.breakpoints.medium}) {
        width: 100%;
    }
`

export const Content = styled.p`
    text-align: left;
    width: 30%;
    margin: auto;
    padding: 1rem;
    box-sizing: border-box;

    @media only screen and (max-width: ${globalStyles.breakpoints.medium}) {
        width: 100%;
    }
`